
export default {
  name: 'IconTrash',
};
